export default {
    name: 'ClickOutside',
    props: {
        call: {
            type: Function,
            default: () => { },
        },
        isEnabled: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        const handleClick = e => {
            if (e.target !== this.$el && !this.$el.contains(e.target) && this.isEnabled) {
                this.call();
            }
        };

        document.addEventListener('mousedown', handleClick);
        this._clickOutsideCleanup = () => document.removeEventListener('mousedown', handleClick);
    },
    beforeUnmount() {
        if (this._clickOutsideCleanup) {
            this._clickOutsideCleanup();
        }
    },
    render() {
        return this.$slots.default?.()?.[0] ?? null;
    },
};